"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var MasterCardLogo_1 = require("../../../common/assets/creditCardLogos/MasterCardLogo");
var VisaLogoMulti_1 = require("../../../common/assets/creditCardLogos/VisaLogoMulti");
var CreditCardBrands_1 = require("../../../common/enum/CreditCardBrands");
var core_1 = require("@material-ui/core");
var Translation_1 = require("../../../common/components/presentation/Translation/Translation");
var ContentLine_1 = require("../contentLine/ContentLine");
var userDetailsStyles_1 = require("./userDetailsStyles");
var UserPaymentDetails = function (_a) {
    var transactionDetails = _a.transactionDetails;
    var _b, _c, _d;
    var style = userDetailsStyles_1.default();
    var cardBrand = react_1.useCallback(function () {
        if (transactionDetails.brand === CreditCardBrands_1.CreditCardBrands.VISA) {
            return <VisaLogoMulti_1.default className={style.cardLogo}/>;
        }
        else if (transactionDetails.brand === CreditCardBrands_1.CreditCardBrands.MASTERCARD) {
            return <MasterCardLogo_1.default />;
        }
        return null;
    }, []);
    return (<>
      {((_b = transactionDetails) === null || _b === void 0 ? void 0 : _b.brand) && (<ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1">
              <Translation_1.default id="payment.cardDetails.cardBrand"/>
            </core_1.Typography>} secondaryContent={<core_1.Typography variant="subtitle1">{cardBrand()}</core_1.Typography>} dataTest={"summary:card_details:cardBrand"}/>)}
      {((_c = transactionDetails) === null || _c === void 0 ? void 0 : _c.cardNumber) && (<ContentLine_1.default mainContent={<core_1.Typography variant="subtitle1">
              <Translation_1.default id="payment.cardDetails.creditCardMaskInformation"/>
            </core_1.Typography>} secondaryContent={<core_1.Typography variant="subtitle1">{(_d = transactionDetails) === null || _d === void 0 ? void 0 : _d.cardNumber}</core_1.Typography>} dataTest={"summary:card_details:cardNumber"}/>)}
    </>);
};
exports.default = UserPaymentDetails;
